import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  PostedAircraftTripSkeleton,
  PostedAircraftTripAudit,
  PostedAircraftTripLegAudit
} from '../../+models/trip-manager-audit.model';

@Component({
  selector: 'sd-portal-trip-manager-trip-audit',
  templateUrl: './trip-manager-trip.component.html',
  styleUrls: ['./trip-manager-trip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TripManagerTripComponent implements OnInit {
  @Input() postedAircraftTripSkeleton: PostedAircraftTripSkeleton;
  @Input() postedAircraftTripAuditLoading: boolean;
  @Input() postedAircraftTripAuditLoaded: boolean;
  @Input() postedAircraftTripAudit: PostedAircraftTripAudit[];
  @Input() postedAircraftTripLegAuditLoading: boolean;
  @Input() postedAircraftTripLegAuditLoaded: boolean;
  @Input() postedAircraftTripLegAudit: PostedAircraftTripLegAudit[];

  @Output() onOpened = new EventEmitter<number>();
  @Output() onNextPage = new EventEmitter<number>();
  @Output() onLegOpened = new EventEmitter<{
    postedAircraftTripId: number;
    postedFlightId: number;
  }>();
  @Output() onLegNextPage = new EventEmitter<{
    postedAircraftTripId: number;
    postedFlightId: number;
  }>();

  constructor() {}

  ngOnInit() {}

  legOpened(postedAircraftTripId: number, postedFlightId: number) {
    this.onLegOpened.emit({ postedAircraftTripId, postedFlightId });
  }

  legNextPage(postedAircraftTripId: number, postedFlightId: number) {
    this.onLegNextPage.emit({ postedAircraftTripId, postedFlightId });
  }
}
